import React, { useCallback } from 'react';
import { useSubscriptions } from '@features/subscriptions/context/subscription-context';
import { Alert, FlexView, Text } from '@goodfynd/ui';

import { SubscriptionCheckoutItem } from './SubscriptionCheckoutItem';

import classes from './SubscriptionsCheckout.module.css';

export function SuiteCheckoutItemList() {
  const { newSuite } = useSubscriptions();

  const renderItems = useCallback(() => {
    if (!newSuite) {
      return (
        <Alert className={classes['no-items']} status="neutral">
          No suite in cart
        </Alert>
      );
    }

    return <SubscriptionCheckoutItem item={newSuite} key={newSuite.sku} />;
  }, [newSuite]);

  return (
    <FlexView direction="column" gap={16} width="100%" wrap="nowrap">
      <Text as="modalHeader">New plan</Text>

      {renderItems()}
    </FlexView>
  );
}
